import React from 'react';
import PropTypes from 'prop-types';

const LoadingCard = ({ title }) => {
    return (
        <div className="load-indicator-contianer">
            <div className="load-indicator" />
            <span>{title}</span>
        </div>
    );
};

LoadingCard.propTypes = {
    title: PropTypes.string,
};
export default LoadingCard;
